import { PROD_URL } from "api/config";
import { URLBuilder } from "../URLBuilder";

// GETS
const URL_GET_ALL_CHALLENGES = (page: number = 1, parameters?: any) =>
	new URLBuilder(`${PROD_URL}/challenges?page=${page}&per_page=20&order_direction=DESC`)
		.withSearchParameters(parameters)
		.build();
const URL_GET_USER_CHALLENGES = (page: number, perPage: number, parameters?: any) =>
	new URLBuilder(`${PROD_URL}/user/challenges?page=${page}&per_page=${perPage}`)
		.withSearchParameters(parameters)
		.build();
const URL_GET_LAST_USER_CHALLENGES = `${PROD_URL}/user/challenges?order_direction=DESC`;
const URL_GET_INVITATIONS_FOR_CHALLENGUE = (slug: string) => `${PROD_URL}/challenges/${slug}/invitations`;
const URL_GET_CHALLENGUE = (slug: string) => `${PROD_URL}/challenges/${slug}`;
// Get config for challenges
const URL_GET_GET_CONFIG_FOR_CHALLENGUE = (id: string) => `${PROD_URL}/institution-profile/${id}/challenge/data`;
// Get config for accelerator and incubator's challenges
const URL_GET_GET_CONFIG_FOR_INVESTOR_CHALLENGUE = (id: string) => `${PROD_URL}/investor-profile/${id}/challenge/data`;
// POSTS
const URL_POST_CHALLENGUE = `${PROD_URL}/challenges`;
const URL_POST_SEND_INVITATIONS = (slugChallenge: string, profileSlug: string) =>
	`${PROD_URL}/challenges/${slugChallenge}/invitation/${profileSlug}`;
const URL_POST_SEND_INVITATION_EMAIL = () => `${PROD_URL}/profiles/challenge/send-invitation`;
const URL_POST_ADD_USER_PROFILES_TO_CHALLENGE = (slug: string) => `${PROD_URL}/challenges/${slug}/add-user-profiles`;
// PATCHS
const URL_PATCH_CHALLENGUE = (slug: string) => `${PROD_URL}/challenges/${slug}`;
const URL_PATCH_INVITATION = (challengeSlug: string, profileSlug: string) =>
	`${PROD_URL}/challenges/${challengeSlug}/invitation/${profileSlug}`;
const URL_PATCH_ADD_ADVISER_TO_CHALLENGUE = (challengeSlug: string, profileSlug: string, consultantSlug: string) =>
	`${PROD_URL}/challenges/${challengeSlug}/profile/${profileSlug}/consultant/${consultantSlug}`;
const URL_PATCH_CHALLENGUE_INSTITUTION_CONFIG = `${PROD_URL}/institution-profile/challenge/institutions`;
const URL_PATCH_CHALLENGUE_COMPANY_CONFIG = `${PROD_URL}/institution-profile/challenge/companies`;
const URL_PATCH_CHALLENGUE_INCUBATOR_CONFIG = `${PROD_URL}/investor-type/challenge/incubator`;
const URL_PATCH_CHALLENGUE_ACCELERATOR_CONFIG = `${PROD_URL}/investor-type/challenge/accelerator`;
// DELETES
const URL_DELETE_CHALLENGUE = (slug: string) => `${PROD_URL}/challenges/${slug}`;
const URL_DELETE_INVITATION = (slug: string, profileSlug: string) =>
	`${PROD_URL}/challenges/${slug}/invitation/${profileSlug}`;
const URL_DELETE_ADVISER_TO_CHALLENGUE = (challengeSlug: string, profileSlug: string, consultantSlug: string) =>
	`${PROD_URL}/challenges/${challengeSlug}/profile/${profileSlug}/consultant/${consultantSlug}`;

export {
	URL_GET_ALL_CHALLENGES,
	URL_GET_USER_CHALLENGES,
	URL_GET_LAST_USER_CHALLENGES,
	URL_GET_INVITATIONS_FOR_CHALLENGUE,
	URL_GET_CHALLENGUE,
	URL_GET_GET_CONFIG_FOR_CHALLENGUE,
	URL_GET_GET_CONFIG_FOR_INVESTOR_CHALLENGUE,
	URL_POST_CHALLENGUE,
	URL_POST_SEND_INVITATIONS,
	URL_POST_SEND_INVITATION_EMAIL,
	URL_POST_ADD_USER_PROFILES_TO_CHALLENGE,
	URL_PATCH_CHALLENGUE,
	URL_PATCH_INVITATION,
	URL_PATCH_ADD_ADVISER_TO_CHALLENGUE,
	URL_PATCH_CHALLENGUE_INSTITUTION_CONFIG,
	URL_PATCH_CHALLENGUE_COMPANY_CONFIG,
	URL_PATCH_CHALLENGUE_INCUBATOR_CONFIG,
	URL_PATCH_CHALLENGUE_ACCELERATOR_CONFIG,
	URL_DELETE_CHALLENGUE,
	URL_DELETE_INVITATION,
	URL_DELETE_ADVISER_TO_CHALLENGUE,
};
